// $('.afsz-fullimagesM').slick({
//   lazyLoad: 'ondemand',
// 	slidesToShow: 1,
// 	slidesToScroll: 1,
// 	arrows: true,
// 	fade: true
//   // ,dots:true
// });
let slidesToScroll_pc = 5;
let page_url_afsz = window.location.href;
if (page_url_afsz.indexOf("openmeetuc-pressure-relief-cushions") >= 0) {
  slidesToScroll_pc = 2;
}
if ($("body").hasClass("openfit2-plus-giftbox-benefits")) {
  slidesToScroll_pc = 6;
}
let fullImageSlick = $(".afsz-fullimages").slick({
  lazyLoad: "ondemand",
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  focusOnSelect: true,
  arrows: true,
  dots: true,
  customPaging: function (slider, index) {
    console.log("slider", slider);
    return `${index + 1}/${slider.slideCount}`;
  },
  prevArrow:
    '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
  asNavFor: ".afsz-thumbs",
});
let peopleFullImageSlick;
if ($(".afsz-fullimages-people > .afsz-fullimages__image").length > 1) {
  peopleFullImageSlick = $(".afsz-fullimages-people").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    focusOnSelect: true,
    arrows: true,
    dots: true,
    customPaging: function (slider, index) {
      console.log("slider", slider);
      return `${index + 1}/${slider.slideCount}`;
    },
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
    asNavFor: ".afsz-people-thumbs",
  });

}

$(".afsz-thumbs").slick({
  lazyLoad: "ondemand",
  vertical: false,
  infinite: false,
  fade: true,
  asNavFor: ".afsz-fullimages",
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
});
$(".afsz-people-thumbs").slick({
  lazyLoad: "ondemand",
  vertical: false,
  infinite: false,
  fade: true,
  prevArrow: false,
  nextArrow: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
  asNavFor: ".afsz-fullimages-people",
});

$("[data-switch]").click(function () {
  $(`[data-switch]`).removeClass("active");
  $(this).addClass("active");
  $(`[data-switch-main]`).removeClass("active");
  $(`[data-switch-main="${$(this).data("switch")}"]`).addClass("active");

  $(".afsz-prod-wrapper").removeClass("has-show-3d active-3d");
  if ($(this).data("switch") == "people") {
    if (peopleFullImageSlick) {
      peopleFullImageSlick.slick(
        "slickGoTo",
        peopleFullImageSlick.slick("slickCurrentSlide")
      );

    }
  }
  if ($(this).data("switch") == "product") {
    fullImageSlick.slick(
      "slickGoTo",
      fullImageSlick.slick("slickCurrentSlide")
    );
    $(".afsz-prod-gallery").addClass("is-product");
  } else {
    $(".afsz-prod-gallery").removeClass("is-product");
  }
});

$(".selectedVariantid").val($("#sVariantid").text());

$(".o-swatch").click(function () {
  var inp = $(this).find("input");
  var selColor = $(inp).val();
  addSelectedColorImg(selColor);
  // if($('body').hasClass('is-template-product')){
  //   document.body.scrollTop = 0;document.documentElement.scrollTop = 0;
  // }
  $(".selectedVariantid").val($("#sVariantid").text());
});

$(".options-color-wrapper").click(function () {
  var selColor = $(this).find(".option-item").attr("data-value") || $(this).attr("data-title");
  var dataOptionName = $(this).attr("data-option-name");
  if (dataOptionName && selColor) {
    $(".radio-wrapper[data-option-name='" + dataOptionName + "'] .current-option-color").text(selColor);
  }
  addSelectedColorImg(selColor);
  const varId = $(this).attr("data-var_id");
  console.log("varId::", varId);
  if (varId == "51721464152397") {
    $(".afsz-prod-gallery .credentials-img").eq(0).css("display", "none");
  } else {
    $(".afsz-prod-gallery .credentials-img").eq(0).css("display", "");
  }
});

var now_product_handle = $(".c-variant-selector__swatches-wrapper").attr(
  "product-handle"
);

if (
  now_product_handle == "opencomm2uc" ||
  now_product_handle == "opencomm2uc2025upgrade" ||
  now_product_handle == "openmeet"
) {
  //处理openrun加磁浮类型2uc产品无法展示橱窗图
  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  sCol = sCol.replace(" ", "-/-");
  addSelectedColorImg(sCol);
} else {
  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  addSelectedColorImg(sCol);
}

if ($(".connectivity.o-toggle .o-toggle__switch.is-active").length > 0) {
  addSelectedColorImg("USB-A");
}

function addSelectedColorImg(col) {
  console.log("col:", col);
  let newCol = col;
  if (col.includes("+")) {
    newCol = col.split("+")[0];
  }
  if (col.includes("/")) {
    newCol = col.replace("/", "\\/");
  }

  if ($(".afsz-prod-wrapper").hasClass("fl")) {
    var selectedColor = "." + newCol;
    selectedColor = selectedColor.trim().replaceAll(" ", "-");
    // console.log(selectedColor,"selectedColor");
    $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickUnfilter");
    $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickFilter", selectedColor);
    $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickGoTo", 0);

    $(".afsz-prod-wrapper.fl .afsz-fullimages").slick("slickUnfilter");
    $(".afsz-prod-wrapper.fl .afsz-fullimages").slick(
      "slickFilter",
      selectedColor
    );
    $(".afsz-prod-wrapper.fl .afsz-fullimages").slick("slickGoTo", 0);
    setTimeout(function () {
      $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickGoTo", 0);
      $(".afsz-prod-wrapper.fl .afsz-fullimages").slick("slickGoTo", 0);
      $(".afsz-thumbs .afsz-thumbs__thumb").click(function () {
        let now_index =
          parseInt($(this).attr("data-slick-index")) % slidesToScroll_pc;
        setTimeout(function () {
          console.log(now_index);
          $(".afsz-prod-wrapper.fl .afsz-fullimages").slick(
            "slickGoTo",
            now_index
          );
        }, 500);
      });
    }, 100);

    // $('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickUnfilter');
    //  	$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickFilter',selectedColor);
    //    $('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickGoTo', 0);
  }
}
